<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <!-- <el-button-group class="mb-3">
          <el-button @click="() => $refs.searchForm.toggleShow()">筛选</el-button>
        </el-button-group>

        <search-form ref="searchForm" :fields="search"/> -->
    <!-- 搜索头 -->
    <div class="filters">
      <!-- <el-button-group class="mb-3">
              <el-button @click="() => $refs.searchForm.toggleShow()">筛选</el-button>
            </el-button-group> -->
      <search-form
        ref="searchForm"
        :fields="search"
      />

      <div class="selections">
        <el-button-group>
          <el-button
            type="primary"
            @click="clickBikesMul"
            size="medium"
            round
          >
            批量操作
          </el-button>
          <el-button
            type="danger"
            @click="clickBikesSettingMul"
            size="medium"
            round
          >
            批量配置中控
          </el-button>
        </el-button-group>
      </div>
    </div>

    <!-- 表格 -->

    <el-table
      ref="multipleTable"
      :data="bikes"
      resource="bike"
      :row-key="row.id"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        :reserve-selection="true"
        :column-key="row.id"
        width="55"
        prop="id"
      />

      <!--<el-table-column prop="id" label="ID" width="100"/>-->
      <el-table-column
        prop="bike_no"
        label="车辆编号"
        min-width="120"
      />
      <el-table-column
        prop="box_no"
        label="控制器编号"
        min-width="120"
      />

      <el-table-column
        label="投放状态"
        min-width="100"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.put_status"
            type="success"
          >已投放</el-tag>
          <el-tag
            v-else
            type="danger"
          >未投放</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="在线状态"
        min-width="100"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.is_link"
            type="success"
          >在线</el-tag>
          <el-tag
            v-else
            type="danger"
          >离线</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="故障状态"
        min-width="100"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.is_trouble"
            type="danger"
          >有故障</el-tag>
          <el-tag
            v-else
            type="success"
          >无故障</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="剩余电量"
        min-width="150"
      >
        <template slot-scope="scope">
          <el-progress :percentage="scope.row.battery_power" />
        </template>
      </el-table-column>
      <el-table-column
        prop="put_area"
        label="投放区域"
      />
      <el-table-column label="投放时间">
        <template slot-scope="scope">
          <el-tag>{{ scope.row.put_time }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        min-width="300"
      >
        <template #default="{ row }">
          <el-button
            type="warning"
            size="small"
            plain
            @click="qcodeClick(row)"
          >
            操作
          </el-button>
          <el-button
            type="danger"
            size="small"
            plain
            v-show="row.box !== ''"
            @click="dialogBoxFormShow(row)"
          >
            配置中控
          </el-button>

          <el-button
            type="info"
            size="small"
            plain
            v-show="row.box !== ''"
            @click="queryConfig(row)"
          >
            查询配置
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 表格end -->
    <!-- 车辆二维码 -->
    <el-dialog
      title="车辆二维码"
      :visible.sync="dialogQrCodeVisible"
      width="30%"
      style="text-align:center;"
    >
      <img
        :src="QrCodeUrl"
        width="300px"
        height="300px"
        alt="二维码"
      >
      <div class="bigC">
        <div class="titleDiv">车辆控制:</div>
        <div class="detailDiv">
          <p>
            <el-button
              type="success"
              class="btnL"
              @click="controBike('bell')"
            >寻车</el-button>
            <el-button
              type="warning"
              class="btnL"
              @click="controBike('openLock')"
            >开锁</el-button>
            <el-button
              type="info"
              class="btnL"
              @click="controBike('closeLock')"
            >关锁</el-button>
            <el-button
              type="danger"
              class="btnL"
              @click="controBike('openBatteryLock')"
            >开电池锁</el-button>

            <el-button
              type="danger"
              class="btnL"
              @click="controBike('outLoseElectric')"
            >车辆失能</el-button>
            <el-button
              class="btnL"
              type="success"
              @click="controBike('outGetElectric')"
            >车辆获能</el-button>
          </p>
        </div>
      </div>
      <div class="bigC">
        <div class="titleDiv">状态更新:</div>
        <div class="detailDiv">
          <p>
            <el-button
              type="primary"
              class="btnL"
              @click="controBike('rebootBox')"
            >重启中控</el-button>
            <el-button
              type="primary"
              class="btnL"
              @click="controBike('nowBikeLocation')"
            >立即定位</el-button>
            <el-button
              class="btnL"
              type="primary"
              @click="controBike('nowBikeBatteryMSG')"
            >立即更新电量</el-button>

            <el-button
              class="btnL"
              type="primary"
              @click="controBike('repair')"
            >恢复正常</el-button>
            <el-button
              class="btnL"
              type="danger"
              @click="innerVisible = true"
            >重置总收益</el-button>
          </p>
        </div>
      </div>
      <div class="bigC">
        <div class="titleDiv">语音控制:</div>
        <div class="detailDiv">
          <p>
            <el-select
              style="width: 250px; margin-right:10px"
              v-model="video"
              placeholder="请选择"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-button
              type="danger"
              @click="controBike('video',video)"
            >发送</el-button>
          </p>
        </div>
      </div>

      <el-dialog
        width="30%"
        title="重置总收益"
        :visible.sync="innerVisible"
        append-to-body
      >
        <lz-form
          ref="resetForm"
          :submit="resetOnSubmit"
          :model="resetForm"
          :edit-mode="resetIsedit"
          :rules="resetRules"
          :errors.sync="resetErrors"
          :disable-redirect="true"
          :in-dialog="true"
          label-width="225px"
          style="margin:10px 0;"
        >
          <el-form-item
            required
            prop="total_money_time"
            label="车辆总收益起始时间"
          >
            <el-date-picker
              v-model="resetForm.total_money_time"
              type="datetime"
              placeholder="选择日期时间"
              value-format="yyyy-MM-dd HH:mm:ss"
            />
          </el-form-item>
          <el-form-item
            required
            prop="is_reset_total_money"
            label="总收益"
          >
            <el-radio
              v-model="resetForm.is_reset_total_money"
              label="1"
            >清零</el-radio>
            <el-radio
              v-model="resetForm.is_reset_total_money"
              label="2"
            >保持不变</el-radio>
            <el-radio
              v-model="resetForm.is_reset_total_money"
              label="3"
            >根据时间自动计算</el-radio>
          </el-form-item>
        </lz-form>
      </el-dialog>
    </el-dialog>
    <!-- 车辆二维码end -->
    <!-- 弹窗批量设置表单 -->
    <el-dialog
      title="批量操作"
      :visible.sync="dialogFormVisible"
      width="40%"
    >
      <div class="cen">
        <div>
          <p class="downloadp">
            <span class="downloadform">选择范围：</span>
            <el-radio
              v-model="radio_download"
              @change="radioDownloadChange"
              label="1"
            >勾选项</el-radio>
            <el-radio
              v-model="radio_download"
              @change="radioDownloadChange"
              label="2"
            >本页</el-radio>
            <!-- <el-radio v-model="radio_download" @change="radioDownloadChange" label="3">全部</el-radio> -->
          </p>
          <p class="downloadp">
            <span class="downloadform">已选数量：</span> <span>已选择{{ download_number }}个</span>
          </p>
          <div class="bigC">
            <div class="titleDiv">车辆控制:</div>
            <div class="detailDiv">
              <p>
                <el-button
                  type="success"
                  class="btnL"
                  @click="submitMul('bell')"
                >批量寻车</el-button>
                <el-button
                  type="warning"
                  class="btnL"
                  @click="submitMul('openLock')"
                >批量开锁</el-button>
                <el-button
                  type="info"
                  class="btnL"
                  @click="submitMul('closeLock')"
                >批量关锁</el-button>
                <el-button
                  type="danger"
                  class="btnL"
                  @click="submitMul('openBatteryLock')"
                >批量开电池锁</el-button>

                <el-button
                  type="danger"
                  class="btnL"
                  @click="submitMul('outLoseElectric')"
                >批量车辆失能</el-button>
                <el-button
                  class="btnL"
                  type="success"
                  @click="submitMul('outGetElectric')"
                >批量车辆获能</el-button>
              </p>
            </div>
          </div>
          <div class="bigC">
            <div class="titleDiv">状态更新:</div>
            <div class="detailDiv">
              <p>
                <el-button
                  type="primary"
                  class="btnL"
                  @click="submitMul('rebootBox')"
                >批量重启中控</el-button>
                <el-button
                  type="primary"
                  class="btnL"
                  @click="submitMul('nowBikeLocation')"
                >批量立即定位</el-button>
                <el-button
                  type="primary"
                  class="btnL"
                  @click="submitMul('nowBikeBatteryMSG')"
                >批量立即更新电量</el-button>
                <el-button
                  type="primary"
                  class="btnL"
                  @click="submitMul('repair')"
                >批量恢复正常</el-button>

                <el-button
                  class="btnL"
                  type="danger"
                  @click="innerVisibleMul=true"
                >重置总收益</el-button>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <!-- <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button> -->
      </div>

      <el-dialog
        width="40%"
        title="批量重置总收益"
        :visible.sync="innerVisibleMul"
        append-to-body
      >
        <el-card
          class="cen"
          style="margin-bottom:20px;"
        >
          <div>
            <p class="downloadp">
              <span class="downloadform">选择范围：</span>
              <el-radio
                v-model="radio_download"
                @change="radioDownloadChange"
                label="1"
              >勾选项</el-radio>
              <el-radio
                v-model="radio_download"
                @change="radioDownloadChange"
                label="2"
              >本页</el-radio>
              <!-- <el-radio v-model="radio_download" @change="radioDownloadChange" label="3">全部</el-radio> -->
            </p>
            <p class="downloadp">
              <span class="downloadform">已选数量：</span> <span>已选择{{ download_number }}个</span>
            </p>
          </div>
        </el-card>
        <el-card style="margin-bottom:20px;">
          <lz-form
            ref="resetForm"
            :submit="resetOnSubmitMul"
            :model="resetForm"
            :edit-mode="resetIsedit"
            :rules="resetRules"
            :errors.sync="resetErrors"
            :disable-redirect="true"
            :in-dialog="true"
            label-width="225px"
            style="margin:10px 0;"
          >
            <el-form-item
              required
              prop="total_money_time"
              label="车辆总收益起始时间"
            >
              <el-date-picker
                v-model="resetForm.total_money_time"
                type="datetime"
                placeholder="选择日期时间"
                value-format="yyyy-MM-dd HH:mm:ss"
              />
            </el-form-item>
            <el-form-item
              required
              prop="is_reset_total_money"
              label="总收益"
            >
              <el-radio
                v-model="resetForm.is_reset_total_money"
                label="1"
              >清零</el-radio>
              <el-radio
                v-model="resetForm.is_reset_total_money"
                label="2"
              >保持不变</el-radio>
              <el-radio
                v-model="resetForm.is_reset_total_money"
                label="3"
              >根据时间自动计算</el-radio>
            </el-form-item>
          </lz-form>
        </el-card>
      </el-dialog>
    </el-dialog>
    <!-- 批量设置表单end -->
    <!-- 中控配置表单 -->
    <el-dialog
      title="中控配置"
      :visible.sync="dialogBoxFormVisible"
      width="40%"
      :before-close="handleClose"
    >
      <el-card style="margin:20px">
        <lz-form
          ref="boxForm"
          :submit="onSubmitBox"
          :model="boxForm"
          :rules="boxRules"
          :edit-mode="isedit"
          :errors.sync="boxErrors"
          :disable-redirect="true"
          :in-dialog="true"
          label-width="220px"
          style="margin:10px 0;"
        >
          <el-form-item label="车辆编号">
            <el-input
              v-model="bike_no"
              disabled
            />
          </el-form-item>
          <el-form-item
            required
            prop="box_no"
            label="中控编号"
          >
            <el-input
              v-model="boxForm.box_no"
              disabled
            />
          </el-form-item>
          <el-form-item
            required
            prop="pulse"
            label="心跳间隔时间（秒）"
          >
            <el-input-number
              v-model="boxForm.pulse"
              :min="10"
              :max="1200"
            />
          </el-form-item>
          <el-form-item
            required
            prop="freq"
            label="骑行定位包间隔时间（秒）"
          >
            <el-input-number
              v-model="boxForm.freq"
              :min="5"
              :max="60"
            />
          </el-form-item>
          <el-form-item
            required
            prop="vibfilterremindt"
            label="骑行时静止多少分钟锁车（分）"
          >
            <el-input-number
              v-model="boxForm.vibfilterremindt"
              :min="1"
              :max="60"
            />
          </el-form-item>
          <el-form-item
            required
            prop="server"
            label="配置服务器地址"
          >
            <!-- <el-input v-model="boxForm.server" placeholder="请输入配置服务器地址"/> -->
            <el-select
              v-model="boxForm.server"
              filterable
              allow-create
              default-first-option
              placeholder="请输入配置服务器地址"
            >
              <el-option
                v-for="item in serverOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <!-- <el-form-item required prop="blekg" label="蓝牙功能开关">
            <el-switch
              v-model="boxForm.blekg"
              active-text="开"
              inactive-text="关"
            />
          </el-form-item> -->
          <el-form-item
            required
            prop="maxecuspeed"
            label="速度选择"
          >
            <el-select
              v-model="boxForm.maxecuspeed"
              placeholder="请选择"
            >
              <el-option
                v-for="item in speedOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </lz-form>
      </el-card>
      <el-card
        style="margin:20px"
        v-show="resShow"
      >
        <div class="responses">
          <div>
            <p class="downloadp">
              <span class="downloadform">心跳间隔时间修改:</span>
              <span>{{ tables.pulse }}</span>
            </p>
            <p class="downloadp">
              <span class="downloadform">骑行定位包间隔时间修改:</span>
              <span>{{ tables.freq }}</span>
            </p>
            <p class="downloadp">
              <span class="downloadform">骑行时静止多少分钟锁车修改:</span>
              <span>{{ tables.vibfilterremindt }}</span>
            </p>
          </div>
          <div>
            <p class="downloadp">
              <span class="downloadform">服务器地址修改:</span>
              <span>{{ tables.server }}</span>
            </p>
            <p class="downloadp">
              <span class="downloadform">蓝牙开关修改:</span>
              <span>{{ tables.blekg }}</span>
            </p>
            <p class="downloadp">
              <span class="downloadform">速度修改:</span>
              <span>{{ tables.maxecuspeed }}</span>
            </p>
          </div>
        </div>
      </el-card>
    </el-dialog>
    <!-- 中控配置表单end -->

    <!-- 批量中控配置表单 -->
    <el-dialog
      title="批量中控配置"
      :visible.sync="dialogMulBoxFormVisible"
      width="40%"
    >
      <el-card class="mulaa">
        <p class="downloadp">
          <span class="downloadform">选择范围：</span>
          <el-radio
            v-model="radio_download"
            @change="radioDownloadChange"
            label="1"
          >勾选项</el-radio>
          <el-radio
            v-model="radio_download"
            @change="radioDownloadChange"
            label="2"
          >本页</el-radio>
          <!-- <el-radio v-model="radio_download" @change="radioDownloadChange" label="3">全部</el-radio> -->
        </p>
        <p class="downloadp">
          <span class="downloadform">已选数量：</span> <span>已选择{{ box_ids_num }}个</span>
        </p>
      </el-card>
      <el-card class="mulaaa">
        <lz-form
          ref="boxFormMul"
          :submit="onSubmitBoxMul"
          :model="boxFormMul"
          :rules="boxRulesMul"
          :edit-mode="iseditMul"
          :errors.sync="boxErrorsMul"
          :disable-redirect="true"
          :in-dialog="true"
          label-width="220px"
          style="margin:10px 0;"
        >
          <!-- <el-form-item required prop="box_no" label="中控编号">
          <el-input v-model="boxFormMul.box_no" disabled/>
        </el-form-item> -->
          <el-form-item
            required
            prop="pulse"
            label="心跳间隔时间（秒）"
          >
            <el-input-number
              v-model="boxFormMul.pulse"
              :min="10"
              :max="1200"
            />
          </el-form-item>
          <el-form-item
            required
            prop="freq"
            label="骑行定位包间隔时间（秒）"
          >
            <el-input-number
              v-model="boxFormMul.freq"
              :min="5"
              :max="60"
            />
          </el-form-item>
          <el-form-item
            required
            prop="vibfilterremindt"
            label="骑行时静止多少分钟锁车（分）"
          >
            <el-input-number
              v-model="boxFormMul.vibfilterremindt"
              :min="1"
              :max="60"
            />
          </el-form-item>
          <el-form-item
            required
            prop="server"
            label="配置服务器地址"
          >
            <!-- <el-input v-model="boxFormMul.server" placeholder="请输入配置服务器地址"/> -->
            <el-select
              v-model="boxFormMul.server"
              filterable
              allow-create
              default-first-option
              placeholder="请输入配置服务器地址"
            >
              <el-option
                v-for="item in serverOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <!-- <el-form-item required prop="blekg" label="蓝牙功能开关">
            <el-switch
              v-model="boxFormMul.blekg"
              active-text="开"
              inactive-text="关"
            />
          </el-form-item> -->
          <el-form-item
            required
            prop="maxecuspeed"
            label="速度选择"
          >
            <el-select
              v-model="boxFormMul.maxecuspeed"
              placeholder="请选择"
            >
              <el-option
                v-for="item in speedOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </lz-form>
      </el-card>
    </el-dialog>
    <!-- 中控配置表单end -->

    <!-- 查询中控 -->
    <el-dialog
      title="中控配置"
      :visible.sync="dialogBoxConfigVisible"
      width="40%"
    >
      <el-card
        v-loading="loading"
        style="margin:20px"
      >
        <div>
          <p class="downloadp">
            <span class="downloadform">心跳间隔时间:</span>
            <span>{{ configs.pulse }}</span>
          </p>
          <p class="downloadp">
            <span class="downloadform">骑行定位包间隔时间:</span>
            <span>{{ configs.freq }}</span>
          </p>

          <p class="downloadp">
            <span class="downloadform">自动锁车时间:</span>
            <span>{{ configs.auto_lock_time }}</span>
          </p>

          <p class="downloadp">
            <span class="downloadform">服务器地址:</span>
            <span>{{ configs.server }}</span>
          </p>
          <p class="downloadp">
            <span class="downloadform">速度:</span>
            <span>{{ configs.maxecuspeed }}(1最慢 7最快)</span>
          </p>
          <p class="downloadp">
            <span class="downloadform">软件版本号:</span>
            <span>{{ configs.softversion }}</span>
          </p>
        </div>
      </el-card>
    </el-dialog>
    <!-- 查询中控end -->

    <div class="card-footer">
      <pagination :page="page" />
    </div>
  </el-card>
</template>
<script>
import Pagination from "@c/Pagination";
import SearchForm from "@c/SearchForm";
import { getBikes, mulBikesContro, bikeQrCode } from "@/api/bike";
import { getAreas } from "@/api/area";
import {
  settingBox,
  settingMulBox,
  getServerOptions,
  getConfigs
} from "@/api/box";
import { mixinsAutoPageSize } from "@/libs/utils";
import LzForm from "@c/LzForm";
import { getAdminUsersMerchant } from "@/api/admin-merchant";
import env from "../../env";
export default {
  name: "Index",
  components: {
    LzForm,
    Pagination,
    SearchForm
  },
  data() {
    return {
      search: [
        {
          type: "super-input",
          field: "bike_or_box",
          label: "车牌号 / 控制器号"
        },
        {
          type: "el-select",
          field: "is_link",
          label: "是否在线",
          options: [
            {
              id: "",
              name: "全部"
            },
            {
              value: 1,
              label: "在线"
            },
            {
              value: 0,
              label: "离线"
            }
          ]
        },
        {
          type: "el-select",
          field: "put_status",
          label: "是否投放",
          options: [
            {
              id: "",
              name: "全部"
            },
            {
              value: 1,
              label: "已投放"
            },
            {
              value: 0,
              label: "未投放"
            }
          ]
        },
        {
          type: "el-select",
          field: "put_area_id",
          label: "投放区域",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        },
        {
          type: "el-select",
          field: "battery_power",
          label: "选择电量",
          options: [
            {
              id: "",
              name: "全部"
            },
            {
              value: 10,
              label: "小于10%"
            },
            {
              value: 50,
              label: "小于40%"
            },
            {
              value: 70,
              label: "小于60%"
            },
            {
              value: 90,
              label: "小于80%"
            }
          ]
        },
        {
          field: "bike_no_bottom",
          label: "车牌号区间下限"
        },
        {
          field: "bike_no_top",
          label: "车牌号区间上限"
        },
        {
          field: "box_no_bottom",
          label: "控制器号区间下限"
        },
        {
          field: "box_no_top",
          label: "控制器号区间上限"
        }
      ],
      searchs: "",
      bikes: [],
      page: null,
      row: {
        bike_no: "",
        battery_power: Number,
        status: "",
        box_no: "",
        put_area: "",
        put_status: "",
        put_time: "",
        position: "",
        total_money: "",
        box: {}
      },
      boxForm: {
        box_no: "",
        pulse: 30,
        freq: 15,
        vibfilterremindt: "",
        server: "",
        // blekg: 1,
        maxecuspeed: 7
      },
      boxRules: {},
      boxErrors: {},
      speedOptions: [
        {
          value: 1,
          label: "70%"
        },
        {
          value: 2,
          label: "75%"
        },
        {
          value: 3,
          label: "80%"
        },
        {
          value: 4,
          label: "85%"
        },
        {
          value: 5,
          label: "90%"
        },
        {
          value: 6,
          label: "95%"
        },
        {
          value: 7,
          label: "100%"
        }
      ],
      box_id: "",
      dialogBoxFormVisible: false,
      isedit: true,

      boxFormMul: {
        // box_no: '',
        pulse: 120,
        freq: 15,
        vibfilterremindt: 30,
        server: "",
        // blekg: 1,
        maxecuspeed: 7,
        box_ids: []
      },
      boxRulesMul: {},
      iseditMul: true,
      boxErrorsMul: {},
      box_ids: [],
      box_ids_num: 0,
      serverOptions: [], // 服务器地址选项
      bike_no: "",
      dialogMulBoxFormVisible: false,
      resShow: false,
      radio_download: "1",
      download_number: 0,
      multipleSelection: [],
      multipleSelectionBikeNos: [],
      dialogQrCodeVisible: false,
      dialogDownloadVisible: false,
      dialogFormVisible: false,
      QrCodeUrl: "",
      clickBikeId: "",
      tables: {
        pulse: "OK",
        freq: "OK",
        vibfilterremindt: "OK",
        server: "OK",
        blekg: "OK",
        maxecuspeed: "OK"
      },
      dialogBoxConfigVisible: false,
      loading: true,
      configs: {
        pulse: "",
        freq: "",
        server: "",
        maxecuspeed: "",
        softversion: "",
        auto_lock_time: ""
      },
      innerVisible: false,
      innerVisibleMul: false,
      resetIsedit: true,
      resetRules: {},
      resetErrors: {},
      resetForm: {
        is_reset_total_money: "1",
        total_money_time: ""
      },
      options: [],
      optionsTi: [
        {
          value: "01",
          label: "欢迎使用共享电单车"
        },
        {
          value: "02",
          label: "没电了，请换一辆车"
        },
        {
          value: "03",
          label: "骑出运营区，请尽快返回"
        },
        {
          value: "04",
          label: "报警音,车辆未解锁，请扫描骑行"
        },
        {
          value: "05",
          label: "HI,主人，我在这辆车"
        },
        {
          value: "06",
          label: "还车成功，欢迎再次使用共享电单车"
        },
        {
          value: "07",
          label: "寻车提示音"
        },
        {
          value: "08",
          label: "临时锁车"
        },
        {
          value: "09",
          label: "当前不在停车点，请在手机查看停车点"
        },
        {
          value: "0A",
          label: "电池锁已打开"
        },
        {
          value: "0B",
          label: "电池锁已关闭"
        },
        {
          value: "0C",
          label: "距离服务区过远，车辆即将断电"
        },
        {
          value: "0E",
          label: "已超速，请注意减速慢行"
        }
        // {
        //   value: '0E',
        //   label: '车铃音',
        // },
      ],
      optionsWei: [
        {
          value: "01",
          label: "还车成功，请规范停车"
        },
        {
          value: "02",
          label: "开锁成功"
        },
        {
          value: "03",
          label: "请文明骑行规范停车"
        },
        {
          value: "04",
          label: "车辆已断电请回到服务区"
        },
        {
          value: "05",
          label: "车辆已下线"
        },
        {
          value: "06",
          label: "非法移动"
        },
        {
          value: "07",
          label: "临停成功将持续计费"
        },
        {
          value: "08",
          label: "向着诗和远方我们继续出发吧"
        },
        {
          value: "09",
          label: "小喵在这里"
        },
        {
          value: "0A",
          label: "靠近服务区边缘，服务区外将断电"
        },
        {
          value: "0B",
          label: "换电完成您辛苦了"
        },
        {
          value: "0C",
          label: "您已出服务区请尽快骑回"
        },
        {
          value: "0D",
          label: "夜间出行注意安全"
        },
        {
          value: "0E",
          label: "当前为禁停区禁止停车"
        },
        {
          value: "10",
          label: "小喵生病了试试别的车吧"
        },
        {
          value: "11",
          label: "电量过低"
        },
        {
          value: "12",
          label: "主人即将回来试试别的车吧"
        },
        {
          value: "13",
          label: "小猫被预约了试试别的车吧"
        },
        {
          value: "14",
          label: "请停止偷窃行为"
        },
        {
          value: "15",
          label: "您已进入禁停区"
        },
        {
          value: "16",
          label: "车辆已报警请勿移动"
        },
        {
          value: "17",
          label: "请停止偷窃行为"
        },
        {
          value: "18",
          label: "设备已绑定"
        },
        {
          value: "19",
          label: "小喵摔倒了"
        }
      ],
      video: ""
    };
  },
  inject: ["reload"],
  mixins: [mixinsAutoPageSize],
  methods: {
    async resetOnSubmitMul() {
      // 提交多选
      // this.dialogFormVisible = false
      let radios = this.radio_download;
      // var BikeNos = []
      var BikeIds = [];
      // eslint-disable-next-line no-unused-vars
      if (radios === "1") {
        // 勾选项
        BikeIds = this.multipleSelection;
        // BikeNos = this.multipleSelectionBikeNos
      } else if (radios === "2") {
        // BikeNos = this.bikes.map(i => i.bike_no)
        BikeIds = this.bikes.map(i => i.id);
      }
      // console.log(BikeIds)
      const [{ data: res }] = await Promise.all([
        mulBikesContro({
          bikeIds: BikeIds,
          type: "reset_total_money",
          total_money_time: this.resetForm.total_money_time,
          is_reset_total_money: this.resetForm.is_reset_total_money
        })
      ]);

      if (res) {
        // this.$message({
        //   type: 'success',
        //   message: '操作成功!',
        // })
        this.reload();
      }
    },
    async resetOnSubmit() {
      var arrId = [];
      arrId.push(this.clickBikeId);
      const [{ data: res }] = await Promise.all([
        mulBikesContro({
          bikeIds: arrId,
          type: "reset_total_money",
          total_money_time: this.resetForm.total_money_time,
          is_reset_total_money: this.resetForm.is_reset_total_money
        })
      ]);
      if (res) {
        // this.$message({
        //   type: 'success',
        //   message: '操作成功!',
        // })
        this.reload();
      }
    },
    handleSelectionChange(val) {
      this.box_ids = [];
      // 多选改变时触发
      this.multipleSelection = val.map(i => i.id);
      this.multipleSelectionBikeNos = val.map(i => i.bike_no);
      // this.box_ids = val.map(i => i.box.id)
      val.forEach(i => {
        if (i.box.id !== undefined) {
          this.box_ids.push(i.box.id);
        }
      });
      // console.log(this.box_ids)
      this.box_ids_num = this.box_ids.length;
    },
    radioDownloadChange() {
      // 单选选项改变
      let radios = this.radio_download;
      if (radios === "1") {
        this.download_number = this.multipleSelectionBikeNos.length;
        this.box_ids_num = this.box_ids.length;
      } else if (radios === "2") {
        var this_box_ids = [];
        // 本页数量
        this.download_number = this.page.to - this.page.from + 1;
        this.bikes.forEach(i => {
          if (i.box.id !== undefined) {
            this_box_ids.push(i.box.id);
          }
        });
        this.box_ids_num = this_box_ids.length;
        // console.log(this.download_number)
      } else if (radios === "3") {
        this.download_number = this.page.total;
      }
    },
    async qcodeClick(row) {
      this.clickBikeId = row.id;
      const [{ data: QrCodeUrl }] = await Promise.all([
        bikeQrCode({ bike_no: row.bike_no })
      ]);
      this.dialogQrCodeVisible = true;

      this.QrCodeUrl = QrCodeUrl;
      if (row.box_no.length < 10) {
        this.options = this.optionsTi;
      } else {
        this.options = this.optionsWei;
      }
      // console.log(this.QrCodeUrl)
    },
    async submitMul(type) {
      // 提交多选
      this.dialogFormVisible = false;
      let radios = this.radio_download;
      // var BikeNos = []
      var BikeIds = [];
      // eslint-disable-next-line no-unused-vars
      if (radios === "1") {
        // 勾选项
        BikeIds = this.multipleSelection;
        // BikeNos = this.multipleSelectionBikeNos
      } else if (radios === "2") {
        // BikeNos = this.bikes.map(i => i.bike_no)
        BikeIds = this.bikes.map(i => i.id);
      }
      // console.log(BikeIds)

      const [{ data: res }] = await Promise.all([
        mulBikesContro({ bikeIds: BikeIds, type: type })
      ]);

      if (res) {
        this.$message({
          type: "success",
          message: "操作成功!"
        });
        this.reload();
      }
    },
    async controBike(type, command = "") {
      var arrId = [];
      arrId.push(this.clickBikeId);
      var params = { bikeIds: arrId, type: type };
      if (command !== "") {
        params = { bikeIds: arrId, type: type, command: command };
      }
      const [{ data: res }] = await Promise.all([mulBikesContro(params)]);

      if (res) {
        this.$message({
          type: "success",
          message: "操作成功!"
        });
        // this.reload()
      }
    },
    clickBikesMul() {
      // 点击按钮
      this.download_number = this.multipleSelectionBikeNos.length;
      this.dialogFormVisible = true;
    },
    clickBikesSettingMul() {
      // 点击按钮
      this.download_number = this.multipleSelectionBikeNos.length;
      this.dialogMulBoxFormVisible = true;
      let radios = this.radio_download;
      var BoxIds = [];
      if (radios === "1") {
        // 勾选项
        BoxIds = this.box_ids;
        // BikeNos = this.multipleSelectionBikeNos
      } else if (radios === "2") {
        // BikeNos = this.bikes.map(i => i.bike_no)
        // BoxIds = this.bikes.map(i => i.box.id)
        this.bikes.forEach(i => {
          if (i.box.id !== undefined) {
            BoxIds.push(i.box.id);
          }
        });
      }
      this.box_ids_num = BoxIds.length;
    },

    dialogBoxFormShow(row) {
      this.row.box = row.box;
      this.box_id = this.row.box.id;
      this.boxForm.box_no = this.row.box.box_no;
      this.boxForm.pulse = this.row.box.pulse;
      this.boxForm.freq = this.row.box.freq;
      this.boxForm.vibfilterremindt = this.row.box.vibfilterremindt;
      this.boxForm.server = this.row.box.server;
      // this.boxForm.blekg = this.row.box.blekg
      this.boxForm.maxecuspeed = this.row.box.maxecuspeed;
      this.bike_no = row.bike_no;
      this.dialogBoxFormVisible = true;
    },
    async onSubmitBox() {
      // console.log(this.boxForm)
      // await settingBox(this.box_id, this.boxForm)
      const [{ data }] = await Promise.all([
        settingBox(this.box_id, this.boxForm)
      ]);
      var tables = JSON.parse(data);
      this.tables.pulse = tables.PULSE;
      this.tables.freq = tables.FREQ;
      this.tables.vibfilterremindt = tables.VIBFILTERREMINDT;
      this.tables.server = tables.SERVER;
      this.tables.blekg = tables.BLEKG;
      this.tables.maxecuspeed = tables.MAXECUSPEED;
      this.resShow = true;
      // alert(JSON.parse(data))
      // this.reload()
    },
    handleClose() {
      this.reload();
    },
    async onSubmitBoxMul() {
      let radios = this.radio_download;
      var BoxIds = [];
      // eslint-disable-next-line no-unused-vars
      if (radios === "1") {
        // 勾选项
        BoxIds = this.box_ids;
        // BikeNos = this.multipleSelectionBikeNos
      } else if (radios === "2") {
        // BikeNos = this.bikes.map(i => i.bike_no)
        // BoxIds = this.bikes.map(i => i.box.id)
        this.bikes.forEach(i => {
          if (i.box.id !== undefined) {
            BoxIds.push(i.box.id);
          }
        });
      }

      // console.log(BoxIds)

      if (BoxIds.length !== 0) {
        this.boxFormMul.box_ids = BoxIds;
        const [{ data }] = await Promise.all([settingMulBox(this.boxFormMul)]);
        this.reload();
      }
    },
    async queryConfig(row) {
      var boxNo = row.box_no;
      // console.log(box_no)
      this.dialogBoxConfigVisible = true;
      this.loading = true;
      const [{ data }] = await Promise.all([getConfigs({ box_no: boxNo })]);
      this.configs.pulse = data.PULSE;
      this.configs.freq = data.FREQ;
      this.configs.server = data.SERVER;
      this.configs.maxecuspeed = data.MAXECUSPEED;
      this.configs.softversion = data.SOFTVERSION;
      this.configs.auto_lock_time = data.AUTO_LOCK_TIME;
      this.loading = false;
      // console.log(data)
    }
  },
  async created() {
    const [{ data: areas }, { data: serverOptions }] = await Promise.all([
      getAreas({ all: 1 }),
      getServerOptions()
    ]);
    // this.put_areas.push.apply(this.put_areas, areas)
    this.search[3].options.push.apply(this.search[3].options, areas);
    this.serverOptions = serverOptions;
    if (this.$store.state.users.user.roles[0] === "administrator") {
      const [{ data: merchant }] = await Promise.all([
        getAdminUsersMerchant({ all: 1 })
      ]);
      if (env.isPosSwitch == true) {
        this.search.push({
          type: "el-select",
          field: "merchant_id",
          label: "商户",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        });
        this.search[9].options.push.apply(
          this.search[9].options,
          merchant.data
        );
      }
    }
  },
  watch: {
    $route: {
      async handler(newVal) {
        await this.autoPageSize(60, newVal);
        const {
          data: { data, meta }
        } = await getBikes(newVal.query);

        this.bikes = data;
        this.page = meta;

        // console.log(this.put_areas)
      },
      immediate: true
    }
  }
};
</script>
<style lang="scss" scoped>
.filters {
  margin: 10px;
  display: flex;
  justify-content: space-between;
  width: 97%;

  .selectwidth {
    width: 100px;
    margin-right: 15px;
  }

  .searchs {
    width: 200px;
    margin-right: 15px;
  }

  .selections {
    width: 23%;
    margin-right: 10px;
  }
}

.cen {
  display: flex;
  justify-content: center;
  .bigC {
    display: flex;
    .titleDiv {
      width: 9%;
      margin-top: 15px;
    }
    .detailDiv {
      width: 80%;
      text-align: left;
      .btnL {
        margin-bottom: 10px;
        margin-left: 0px;
        margin-right: 10px;
      }
    }
  }
}
.mulaa {
  text-align: center;
  margin: 20px;
  .downloadp {
    width: 100%;
  }
}
.mulaaa {
  margin: 20px;
}
.responses {
  display: flex;
  justify-content: space-between;
  div {
    width: 50%;
    text-align: center;
  }
}
.bigC {
  display: flex;
  .titleDiv {
    width: 15%;
    margin-top: 15px;
  }
  .detailDiv {
    width: 80%;
    text-align: left;
    .btnL {
      margin-bottom: 10px;
      margin-left: 0px;
      margin-right: 10px;
    }
  }
}
</style>
